/* Import Local Modules */
import GatewayManufacturingLogUploadAction from './GatewayManufacturingLogUploadAction';
import GatewayManufacturingLogRevertAction from './GatewayManufacturingLogRevertAction';
import GatewayShipmentLogUploadAction from './GatewayShipmentLogUploadAction';
import TagShipmentLogUploadAction from './TagShipmentLogUploadAction';
import TagShipmentLogRevertAction from './TagShipmentLogRevertAction';
import TagManufacturingLogRevertAction from './TagManufacturingLogRevertAction';
import TagManufacturingLogUploadAction from './TagManufacturingLogUploadAction';
export default {
  install: molten => {
    molten.addPlugin('Action', GatewayManufacturingLogUploadAction);
    molten.addPlugin('Action', GatewayManufacturingLogRevertAction);
    molten.addPlugin('Action', GatewayShipmentLogUploadAction);
    molten.addPlugin('Action', TagManufacturingLogUploadAction);
    molten.addPlugin('Action', TagManufacturingLogRevertAction);
    molten.addPlugin('Action', TagShipmentLogUploadAction);
    molten.addPlugin('Action', TagShipmentLogRevertAction);
  }
};